import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import Empty from "../../components/Empty/Empty";
import { useTranslation } from "react-i18next";
import List from "./components/LIST";
import LazyImage from "../../components/Loading/lazyImage";
import TopTab from "../Home/components/topTab";
import useDeviceType from "../../hook/useDeviceType";

const Promotion = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`promotions.${key}`);

  const isMobile = useDeviceType() === "Mobile";

  const promotion = List();

  const [promotionList, setPromotionList] = useState([]);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  // const promotion = useMemo(() => {
  //   return getPromotionImages(i18n.language);
  // }, [i18n.language]);

  useEffect(() => {}, []);

  return (
    <motion.main>
      <section className="md:hidden">
        <TopTab />
      </section>
      <section className="px-common-padding-x py-common-padding-y">
        <p
          className={`text-base-light-dark dark:text-base-light-white sm:text-2xl text-xl font-semibold mb-[0px]`}
        >
          {i18n("title")}
        </p>

        <section className="mt-[16px] md:grid grid-cols-3 gap-[20px]">
          {promotion.length === 0 ? (
            <Empty />
          ) : (
            promotion.map((item, index) => {
              return (
                <section
                  onClick={() => {
                    navigate(`/promotion/detail/${index}`);
                  }}
                  key={index}
                  className="w-full rounded-[5px] group bg-white overflow-hidden h-[300px] relative cursor-pointer mb-[15px]"
                >
                  {/* <img
                  className="w-[150px] h-[160px] absolute top-0 right-0 object-cover"
                  src={item}
                /> */}
                  <div className="w-full h-[200px] overflow-hidden">
                    <LazyImage
                      className="object-cover h-full w-full group-hover:scale-[1.15] group-hover:-rotate-3 transition "
                      src={isMobile ? item.image_mobile : item.image_pc}
                    />
                  </div>
                  <div className="bg-base-light-white dark:bg-base-light-dark h-[100px] flex flex-col gap-[10px] p-[10px]">
                    <span className="font-semibold text-xl group-hover:text-main-color text-base-light-dark dark:text-base-light-white">
                      {item.title}
                    </span>
                    <span className="font-medium text-sm text-base-light-dark dark:text-base-light-white text-overflow">
                      {item.subTitle}
                    </span>
                  </div>
                </section>
              );
            })
            // promotionList.map((promotion, index) => {
            //   const sectionColor = PROMOTION_BANNER_BACKGROUND[index % 3];
            //   const uid = promotion.uid;
            //   const title = promotion.title;
            //   const date = promotion.createDate;
            //   const imgLink = promotion.img;
            //   const encodeMessage = promotion.content;

            //   const message = JSON.stringify(Base64.decode(promotion.content));
            //   const parser = new DOMParser();
            //   const htmlDocument = parser.parseFromString(message, "text/html");
            //   const textContent =
            //     htmlDocument.body.textContent.slice(1, -1) || "";

            //   return (
            //     <section
            //       key={index}
            //       className="w-full rounded-[10px] bg-third-color min-h-[145px] p-[16px] relative cursor-pointer mb-[15px]"
            //       onClick={() => {
            //         navigate(
            //           `promotioncontent?title=${title}&content=${encodeMessage}&date=${date}&link=${Base64.encode(
            //             imgLink
            //           )}`
            //         );
            //       }}
            //     >
            //       <div className="flex flex-col w-[40%] max-h-[145px] overflow-hidden">
            //         <p className="text-white text-lg mb-[5px] font-semibold">
            //           {title}
            //         </p>
            //         <div
            //           className="text-light-text text-sm font-light break-all text-overflow"
            //           style={{ whiteSpace: "unset" }}
            //         >
            //           {textContent}
            //         </div>
            //       </div>
            //       <div className="overflow-hidden absolute top-0 left-0 w-full h-full rounded-[10px]">
            //         <span
            //           className="absolute right-0 h-[150px] w-[150px] blur-[50px]"
            //           style={{
            //             background: sectionColor,
            //           }}
            //         ></span>
            //       </div>
            //       <img
            //         className="w-[150px] h-[160px] absolute top-0 right-0 object-cover"
            //         src={promotion.background}
            //       />
            //     </section>
            // );
            // })
          )}
        </section>
      </section>
    </motion.main>
  );
};

export default Promotion;
